module.exports = __webpack_public_path__ + "img/Ford-SRS-111921-DealerDraft-Modern.021caeb3.jpeg";